"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateExperimentAdEntityStatusRequestToJSON = exports.UpdateExperimentAdEntityStatusRequestFromJSONTyped = exports.UpdateExperimentAdEntityStatusRequestFromJSON = exports.instanceOfUpdateExperimentAdEntityStatusRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateExperimentAdEntityStatusRequest interface.
 */
function instanceOfUpdateExperimentAdEntityStatusRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateExperimentAdEntityStatusRequest = instanceOfUpdateExperimentAdEntityStatusRequest;
function UpdateExperimentAdEntityStatusRequestFromJSON(json) {
    return UpdateExperimentAdEntityStatusRequestFromJSONTyped(json, false);
}
exports.UpdateExperimentAdEntityStatusRequestFromJSON = UpdateExperimentAdEntityStatusRequestFromJSON;
function UpdateExperimentAdEntityStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isExposedAudienceCreated': !(0, runtime_1.exists)(json, 'is_exposed_audience_created') ? undefined : json['is_exposed_audience_created'],
        'isControlAudienceCreated': !(0, runtime_1.exists)(json, 'is_control_audience_created') ? undefined : json['is_control_audience_created'],
        'isExposedAudienceMapped': !(0, runtime_1.exists)(json, 'is_exposed_audience_mapped') ? undefined : json['is_exposed_audience_mapped'],
        'isControlAudienceMapped': !(0, runtime_1.exists)(json, 'is_control_audience_mapped') ? undefined : json['is_control_audience_mapped'],
        'isExposedAudienceActivated': !(0, runtime_1.exists)(json, 'is_exposed_audience_activated') ? undefined : json['is_exposed_audience_activated'],
        'isControlAudienceActivated': !(0, runtime_1.exists)(json, 'is_control_audience_activated') ? undefined : json['is_control_audience_activated'],
        'isCampaignCreated': !(0, runtime_1.exists)(json, 'is_campaign_created') ? undefined : json['is_campaign_created'],
        'totalAdSetsCreated': !(0, runtime_1.exists)(json, 'total_ad_sets_created') ? undefined : json['total_ad_sets_created'],
        'totalAssetsCreated': !(0, runtime_1.exists)(json, 'total_assets_created') ? undefined : json['total_assets_created'],
        'totalCreativesCreated': !(0, runtime_1.exists)(json, 'total_creatives_created') ? undefined : json['total_creatives_created'],
        'errorStep': !(0, runtime_1.exists)(json, 'error_step') ? undefined : json['error_step'],
        'adEntityCreationStatus': !(0, runtime_1.exists)(json, 'ad_entity_creation_status') ? undefined : json['ad_entity_creation_status'],
    };
}
exports.UpdateExperimentAdEntityStatusRequestFromJSONTyped = UpdateExperimentAdEntityStatusRequestFromJSONTyped;
function UpdateExperimentAdEntityStatusRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'is_exposed_audience_created': value.isExposedAudienceCreated,
        'is_control_audience_created': value.isControlAudienceCreated,
        'is_exposed_audience_mapped': value.isExposedAudienceMapped,
        'is_control_audience_mapped': value.isControlAudienceMapped,
        'is_exposed_audience_activated': value.isExposedAudienceActivated,
        'is_control_audience_activated': value.isControlAudienceActivated,
        'is_campaign_created': value.isCampaignCreated,
        'total_ad_sets_created': value.totalAdSetsCreated,
        'total_assets_created': value.totalAssetsCreated,
        'total_creatives_created': value.totalCreativesCreated,
        'error_step': value.errorStep,
        'ad_entity_creation_status': value.adEntityCreationStatus,
    };
}
exports.UpdateExperimentAdEntityStatusRequestToJSON = UpdateExperimentAdEntityStatusRequestToJSON;
